/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import SSRProduct from '../ssr-product';
import { useSelector } from 'react-redux';
import { useToast } from '@/hooks/use-toast';

interface BaggageProps {
  baggageData: any;
  activeIndexes: any;
}

const Baggage: React.FC<BaggageProps> = ({ baggageData, activeIndexes }) => {
  const selectedSSR = useSelector(
    (state: any) => state.flightSearch.selectedSSR,
  );
  const baggage = baggageData;
  const { toast } = useToast();
  const [Count, setCount] = useState<number>(0);

  const passengerCount = useSelector(
    (state: any) =>
      state.flightSearch.passengers.adult + state.flightSearch.passengers.child,
  );

  const handleSelected = (count: number) => {
    setCount(count);
  };

  const calculateTotalCounts = (selectedSSR: any) => {
    let totalBaggage = 0;

    if (selectedSSR?.length > 0) {
      selectedSSR.forEach((pax: any) => {
        pax.forEach((flight: any) => {
          flight.forEach((segment: any) => {
            if (segment.baggage) {
              totalBaggage += segment.baggage.count || 0;
            }
          });
        });
      });
    }
    return { totalBaggage };
  };

  return (
    <div>
      {/* Baggage count */}
      <p className="mb-4 text-sm text-gray-500">
        {calculateTotalCounts(selectedSSR)?.totalBaggage} of {passengerCount}{' '}
        baggage(s) selected
      </p>
      <div className="flex h-96 flex-col gap-5 overflow-y-auto">
        {baggage && baggage?.length > 0 && baggage?.map((baggage: any) => (
          <SSRProduct
            key={baggage.id}
            data={baggage}
            type="baggage"
            selected={handleSelected}
            activeIndexes={activeIndexes}
            count={Count}
          />
        ))}
        {baggage && baggage?.length == 0 && (
          <div className="flex h-full items-center justify-center">
            <p className="text-sm text-gray-500">No baggage data found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Baggage;
